export const obterIdPopoverTipoProbabilidade = (item, index = 0) => {
  return `colprobabilidadeTipo${index}${item.id}`;
};

export const obterIdPopoverTipoSeveridade = (item, index = 0) => {
  return `colseveridadeTipo${index}${item.id}`;
};

export const obterIdPopoverSeveridade = (item) => {
  return `colseveridade${item.id}`;
};

export const obterIdPopoverProbabilidade = (item) => {
  return `colprobabilidade${item.id}`;
};
